import {useNavigate} from "react-router-dom";
import {useState} from "react";
import useHttpHandler from "../../../../hooks/httpHandler";


const useLogin = () => {
    const navigate = useNavigate()
    const {post} = useHttpHandler()

    const [showPassword, setShowPassword] = useState(false);
    const showPasswordClick = () => {
        setShowPassword(state => !state);
    }

    const [showOldPassword, setShowOldPassword] = useState(false);
    const showOldPasswordClick = () => {
        setShowOldPassword(state => !state);
    }
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const showConfirmPasswordClick = () => {
        setShowConfirmPassword(state => !state);
    }
    const [isModal, setIsModal] = useState(false);
    const openForgotPassword = () => {
        navigate('/forgot-password')
    }
    const goBackToLogin = () => {
        navigate('/login')
    }

    const onSubmitLogin=(values, actions)=>{
        post('auth/signin', values).then((res)=>{
            const data = res.data
            sessionStorage.setItem('token',data.accessToken)
            sessionStorage.setItem('userId',data.account_number)
            actions.setSubmitting(false)
            gotoVehicle()
        }).catch(err => {
            actions.setSubmitting(false)
        })

    }

    const gotoVehicle = () => {
        navigate('/vehicle')
    }
    const lowercaseRegex = /(?=.*[a-z])/;
    const uppercaseRegex = /(?=.*[A-Z])/;
    const numericRegex = /(?=.*[0-9])/;
    const nonalphanumeric = /(?=.*[@$!%*#?&])/;
    const alphanumeric = /^[0-9a-zA-Z]*$/;
    const numbersOnly = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
    const phoneNumbersFormat = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
    const charactersRegex = /[A-Za-z0-9@#$* ]/g;

    return {
        phoneNumbersFormat,
        openForgotPassword,
        showPassword,
        showPasswordClick,
        showOldPassword,
        showOldPasswordClick,
        showConfirmPassword,
        showConfirmPasswordClick,
        isModal,
        setIsModal,
        goBackToLogin,
        lowercaseRegex,
        uppercaseRegex,
        numericRegex,
        nonalphanumeric,
        alphanumeric,
        numbersOnly,
        charactersRegex,
        gotoVehicle,
        onSubmitLogin
    }
}
export default useLogin